import { Reducer } from "redux"
import { DevState, DevActionTypes, DEFAULT_RSS_FEED_URL } from "./dev-types"
import { appConfig } from "../../../core/config/app-config"

const initialState: DevState = {
    isDevModeEnabled: appConfig.isDevModeEnabled,
    isNewUIEnabled: appConfig.isNewUIEnabled,
    isInternalModeEnabled: appConfig.isInternalModeEnabled,
    isAlphaModeEnabled: appConfig.isAlphaModeEnabled,
    isDebugFreeMode: false,
    isTestingInstrumentSettings: false,
    isSmrtLinkLiteEnabled: false,
    // Seeded from the env var so .env config sets the default; the /dev "RSS Feed" field
    // overrides it at runtime and persists across reloads. Falls back to DEFAULT_RSS_FEED_URL.
    rssFeedUrl: process.env.REACT_APP_NEWS_FEED_URL || DEFAULT_RSS_FEED_URL,
    // TEMPORARY: off by default until the SL server layer is implemented.
    isInAppCommsEnabled: false,
    isInAppCommsPollingPaused: false,
}

export const devReducer: Reducer<DevState> = (state: DevState = initialState, action: any) => {
    switch (action.type) {
        case DevActionTypes.SET_IS_DEV_MODE_ENABLED:
            return Object.assign({}, state, {
                isDevModeEnabled: action.payload
            })
        case DevActionTypes.SET_IS_NEW_UI_ENABLED:
            return Object.assign({}, state, {
                isNewUIEnabled: action.payload
            })
        case DevActionTypes.SET_IS_INTERNAL_MODE_ENABLED:
            return Object.assign({}, state, {
                isInternalModeEnabled: action.payload
            })
        case DevActionTypes.SET_IS_ALPHA_MODE_ENABLED:
            return Object.assign({}, state, {
                isAlphaModeEnabled: action.payload
            })
        case DevActionTypes.SET_IS_FORCE_FREE_MODE:
            return Object.assign({}, state, {
                isDebugFreeMode: action.payload
            })
        case DevActionTypes.SET_IS_TESTING_INSTRUMENT_SETTINGS:
            return Object.assign({}, state, {
                isTestingInstrumentSettings: action.payload
            })
        case DevActionTypes.SET_IS_SMRTLINK_LITE_ENABLED:
            return Object.assign({}, state, {
                isSmrtLinkLiteEnabled: action.payload
            })
        case DevActionTypes.SET_RSS_FEED_URL:
            return Object.assign({}, state, {
                rssFeedUrl: action.payload
            })
        case DevActionTypes.SET_IS_IN_APP_COMMS_ENABLED:
            return Object.assign({}, state, {
                isInAppCommsEnabled: action.payload
            })
        case DevActionTypes.SET_IS_IN_APP_COMMS_POLLING_PAUSED:
            return Object.assign({}, state, {
                isInAppCommsPollingPaused: action.payload
            })
        default:
            return state
    }
}
